skrilla.directive('marketPurchases',function() {
    return {
        templateUrl: 'directives/marketPurchases/marketPurchases.html',
        scope: {
        },
        controller: function($scope, searchService, queryService, paginationService, cacheService, modalService){
            $scope.key = "marketPurchases";
            $scope.purchases = cacheService.getObjectOrElse($scope.key + "1", []);

            $scope.reset = function(){
                $scope.query = {
                    userId: "",
                    pending: false,
                    approved: false,
                    declined: false,
                    limit: 20
                };
            }
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getPurchases, $scope.key);
            }

            var getPurchases = function () {
                return searchService.get("markets/purchases" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.purchases = response.data.result;
                    cacheService.registerObject($scope.key + "1", $scope.purchases);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.open = function(purchase){
                cacheService.registerObject("marketPurchaseDetails", purchase)
                modalService.openModal("views/marketPurchases/marketPurchaseModal.html", true, 'lg', true, true)
            }

            $scope.getColour = function(purchase){
                switch(purchase.state){
                    case "DECLINED":
                        return "light-red";
                    case "APPROVED":
                        return "light-green";
                    default :
                        return "light-orange";
                }
            }
        }
    };
});
